/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const accordionTokens = {
  WrapperSpacingBottomDefault: '12px',
  WrapperBorderColorDefault: '#c4c4c4',
  WrapperBorderColorHover: '#394040',
  WrapperBorderColorKeyboardFocus: '#285da3',
  WrapperBorderStyleDefault: 'solid',
  WrapperBorderWidthDefault: '1px',
  WrapperBorderRadiusDefault: '4px',
  WrapperBackgroundColorDefault: '#ffffff',
  WrapperShadowColorBaseKeyboardFocus: '#8babd6',
  WrapperShadowWidthBaseKeyboardFocus: '4px',
  HandlerSpacingPaddingDefaultTop: '20px',
  HandlerSpacingPaddingDefaultBottom: '20px',
  HandlerSpacingPaddingDefaultLeft: '32px',
  HandlerSpacingPaddingDefaultRight: '32px',
  HandlerSpacingPaddingCompactTop: '20px',
  HandlerSpacingPaddingCompactBottom: '20px',
  HandlerSpacingPaddingCompactLeft: '16px',
  HandlerSpacingPaddingCompactRight: '32px',
  HeaderSpacingPaddingDefaultTop: '20px',
  HeaderSpacingPaddingDefaultBottom: '20px',
  HeaderSpacingPaddingDefaultLeft: '32px',
  HeaderSpacingPaddingDefaultRight: '32px',
  HeaderSpacingPaddingCompactTop: '20px',
  HeaderSpacingPaddingCompactBottom: '20px',
  HeaderSpacingPaddingCompactLeft: '40px',
  HeaderSpacingPaddingCompactRight: '32px',
  HeaderSpacingGapDefaultDesktop: '56px',
  HeaderSpacingGapDefaultTablet: '12px',
  HeaderSpacingGapDefaultMobile: '12px',
  HeaderBackgroundColorDefault: '#f4f4f4',
  ContentSpacingPaddingDefaultTop: '32px',
  ContentSpacingPaddingDefaultBottom: '32px',
  ContentSpacingPaddingDefaultLeft: '32px',
  ContentSpacingPaddingDefaultRight: '32px',
} as const;
